import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { socialConfig } from './socialConfig';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

const Footer = () => {
  const [socials, setSocials] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
 
 useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const socialQuery = query(collection(db, "socialLinks"), orderBy("name"));
        const socialSnapshot = await getDocs(socialQuery);
        setSocials(socialSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

        // Navbar-এর মতো এখানেও ক্যাটাগরি ফেচ করে order অনুযায়ী সাজিয়ে নেওয়া হলো
        const catQuery = query(collection(db, "categories"));
        const catSnapshot = await getDocs(catQuery);
        const catData = catSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // ঠিক হেডার মেনুর মতো সর্টিং লজিক
        setCategories(catData.sort((a, b) => (a.order || 0) - (b.order || 0)));

      } catch (error) {
        console.error("ফুটারের ডাটা আনতে সমস্যা হয়েছে:", error);
      }
    };

    fetchFooterData();
  }, []);

  // প্রতিটি ক্যাটাগরি থেকে প্রথম পাওয়া লিংকটি ফিল্টার করে নেওয়া
  const mainFacebook = socials.find(s => s.category?.trim() === 'ফেসবুক পেজ');
  const mainYoutube = socials.find(s => s.category?.trim() === 'ইউটিউব চ্যানেল');
  const mainTiktok = socials.find(s => s.category?.trim() === 'টিকটক');
  const mainTwitter = socials.find(s => s.category?.trim() === 'টুইটার');
  const mainInstagram = socials.find(s => s.category?.trim() === 'ইনস্টাগ্রাম');
  const mainWhatsapp = socials.find(s => s.category?.trim() === 'হোয়াটসঅ্যাপ');

  const selectedSocials = [
    mainFacebook, 
    mainYoutube, 
    mainTiktok, 
    mainTwitter, 
    mainInstagram, 
    mainWhatsapp
  ].filter(Boolean);

  return (
    <footer style={{ 
      backgroundColor: '#ffffff',
      color: '#333333',
      padding: '30px 20px 0 20px',
      marginTop: '40px',
      borderTop: '1px solid #d2202a',
      fontFamily: 'sans-serif'
    }}>
      
    {/* ক্যাটাগরি টগল বাটন ও ড্রপডাউন সেকশন (হেডার মেনুর নিচে স্ক্রিনের ওপরের দিকে ওপেন হবে) */}
      <div style={{ marginBottom: '30px', position: 'relative' }}>
        
        {/* টগল বাটন */}
        <button
          onClick={() => setIsCategoryOpen(!isCategoryOpen)}
          onMouseEnter={() => setIsCategoryOpen(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            backgroundColor: '#f1f1f1',
            color: '#333',
            border: '1px solid #ddd',
            padding: '10px 20px',
            fontSize: '16px',
            fontWeight: 'bold',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >
          <span>সকল ক্যাটাগরি ও সাব-ক্যাটাগরি</span>
          <FaChevronRight style={{ transform: isCategoryOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: '0.3s', fontSize: '12px' }} />
        </button>

        {/* ড্রপডাউন ক্যাটাগরি লিস্ট (যা স্ক্রিনের ওপরের অংশে হেডার মেনুর নিচে পপ-আপ হবে) */}
        {isCategoryOpen && (
          <div 
            onMouseLeave={() => setIsCategoryOpen(false)}
            style={{ 
              position: 'fixed',
              top: '70px', // আপনার হেডার মেনুর হাইট অনুযায়ী এটি কম-বেশি করতে পারেন (যেমন: 60px বা 70px)
              left: '50%',
              transform: 'translateX(-50%)',
              width: '90%',
              maxWidth: '1200px',
              backgroundColor: '#ffffff', 
              border: '1px solid #ddd',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
              padding: '20px', 
              zIndex: 9999,
              maxHeight: '75vh',
              overflowY: 'auto',
              borderRadius: '6px'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #d2202a', paddingBottom: '10px', marginBottom: '15px' }}>
              <h3 style={{ margin: 0, color: '#d2202a', fontSize: '18px' }}>সকল ক্যাটাগরি ও সাব-ক্যাটাগরি</h3>
              <button 
                onClick={() => setIsCategoryOpen(false)} 
                style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}
              >
                ✕
              </button>
            </div>

            <div>
              {categories.map((cat) => (
                <div key={cat.id} style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #eee', padding: '12px 0', flexWrap: 'wrap', gap: '15px' }}>
                  
                  <Link 
                    to={`/category/${cat.name}`} 
                    onClick={() => setIsCategoryOpen(false)}
                    style={{ 
                      fontSize: '17px', 
                      fontWeight: '700', 
                      color: '#d2202a', 
                      textDecoration: 'none', 
                      minWidth: '160px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    {cat.name} <FaChevronRight style={{ fontSize: '11px', color: '#666' }} />
                  </Link>

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center' }}>
                    {cat.subcategories && cat.subcategories.length > 0 ? (
                      cat.subcategories.map((sub, index) => (
                        <Link 
                          key={index} 
                          to={`/category/${cat.name}/${sub}`} 
                          onClick={() => setIsCategoryOpen(false)}
                          style={{ 
                            fontSize: '17px', 
                            color: '#000000', 
                            textDecoration: 'none',
                            transition: 'color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.color = '#d2202a'}
                          onMouseLeave={(e) => e.target.style.color = '#333'}
                        >
                          {sub}
                        </Link>
                      ))
                    ) : (
                      <span style={{ fontSize: '14px', color: '#888' }}>কোন সাব-ক্যাটাগরি নেই</span>
                    )}
                  </div>

                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '20px',
        maxWidth: '1200px',
        margin: '0 auto' 
      }}>
        
        {/* সেকশন ১: সম্পাদক ও প্রকাশক */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>সম্পাদক: মুনতাসির রাসেল</span> <br />
            <span style={{ fontWeight: 'bold' }}>প্রকাশক: এরশাদুল করিম রাজু</span> <br />
            উপদেষ্টা আবু রায়হান, প্রতিষ্ঠাতা পন্ডিত সাংস্কৃতিক কেন্দ্র
          </p>
        </div>

        {/* সেকশন ২: কার্যালয় */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>কার্যালয়:</span> এল.এস.ডি. মোড়, চিলমারী, কুড়িগ্রাম
          </p>
        </div>

        {/* সেকশন ৩: মোবাইল ও ই-মেইল */}
        <div style={{ flex: '1 1 250px' }}>
          <p style={{ fontSize: '15px', lineHeight: '1.8', margin: '0' }}>
            <span style={{ fontWeight: 'bold' }}>মোবাইল:</span> ০১৭১৪২৪১৭৬৪ <br />
            <span style={{ fontWeight: 'bold' }}>ই-মেইল:</span> vawaiyaexpress@gmail.com
          </p>
        </div>

        {/* সেকশন ৪: সোশ্যাল মিডিয়া */}
        <div style={{ flex: '1 1 200px' }}>
          <p style={{ fontWeight: 'bold', fontSize: '16px', margin: '0 0 10px 0' }}>সোশ্যাল মিডিয়া</p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {selectedSocials.map(s => {
              const cleanCategory = s.category ? s.category.trim() : '';
              const social = socialConfig[cleanCategory] || socialConfig['অন্যান্য'];
              const IconComponent = social?.icon;
              const brandColor = social?.color || '#333';

              return (
                <a 
                  key={s.id} 
                  href={s.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title={s.name}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    backgroundColor: brandColor,
                    color: '#ffffff',
                    borderRadius: '50%',
                    textDecoration: 'none',
                    fontSize: '16px',
                    transition: 'all 0.3s ease-in-out',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {IconComponent && <IconComponent />}
                </a>
              );
            })}
          </div>
        </div>

      </div>

      {/* কপিরাইট ও ডেভেলপার */}
      <div style={{ 
        textAlign: 'center', 
        marginTop: '30px', 
        paddingBottom: '20px',
        fontSize: '14px',
        color: '#666'
      }}>
        <hr style={{ border: 'none', borderTop: '1px solid #eaeaea', marginBottom: '15px' }} />
        স্বত্ব © ২০২৬ সর্বস্বত্ব সংরক্ষিত। <br />
        Designed & Developed by <span style={{ fontWeight: 'bold', color: '#333' }}>Maruf Billah</span> <br />
        Mobile: 01521478993 (WhatsApp)
      </div>
    </footer>
  );
};

export default Footer;